import { useMutation } from "@tanstack/react-query";

import { ApiError } from "@shared/types";

import { loginService, validateService } from "./service";
import { Login } from "@modules/integration/types/login";
import {
  LoginFormValues,
  ValidateFormValues,
} from "@modules/integration/validations";
import { Validate } from "@modules/integration/types/validate";

export function useTestLoginIntegration(options?: any) {
  return useMutation<Login, ApiError, LoginFormValues>({
    mutationFn: loginService,
    onSuccess: (data: any) => {
      options?.onSuccess?.(data);
    },
    ...options,
  });
}
export function useTestValidateIntegration(
  options?: any
) {

  return useMutation<Validate, ApiError, ValidateFormValues>({
    mutationFn: validateService,
    onSuccess: (data: any) => {
      options?.onSuccess?.(data);
    },
    ...options,
  });
}
